module.exports = __webpack_public_path__ + "img/jacksonville-state-logo.f4b4661a.jpg";